import Upload from './src/upload.vue'
import { SFCWithInstall, withInstall } from '@touchvue/utils'

export const ToUpload: SFCWithInstall<typeof Upload> = withInstall(Upload)

export * from './src/instance'
